module.exports = __webpack_public_path__ + "static/media/Etape2-Signature-Option-n2.109a213c.png";